export default "__VITE_ASSET__c56b4dbb__"